// extracted by mini-css-extract-plugin
export var cartIcon = "_ns-0";
export var cartIconContainer = "_ns-1";